import { getConfigProperty } from '@rootCommon/utilities/config';
import { name as projectName } from '@app/package.json';
import { Projects } from '@rootTypes/projects';

// ENV
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// Projects
export const isControlPanel = Projects.CONTROL_PANEL === projectName;
export const isAdminPanel = Projects.ADMIN_PANEL === projectName;
export const isDashboard = Projects.DASHBOARD === projectName;
export const isQuestionnaire = Projects.QUESTIONNAIRE === projectName;

export const cfAccessClientId = process.env.REACT_APP_CF_ACCESS_CLIENT_ID;
export const cfAccessClientSecret = process.env.REACT_APP_CF_ACCESS_CLIENT_SECRET;
export const httpHeaders = {
  'CF-Access-Client-Id': cfAccessClientId,
  'CF-Access-Client-Secret': cfAccessClientSecret,
};

// Base constants
export const HTTP_API_BASE_URL = getConfigProperty('REACT_APP_HTTP_API_BASE_URL');
export const WS_API_BASE_URL = getConfigProperty('REACT_APP_WS_API_BASE_URL');
export const BASE_APP_URL = isDevelopment
  ? process.env.REACT_APP_HTTP_BASE_URL || window.location.origin
  : window.location.origin;

// Date & Time formats
export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'hh:mma';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mma';
export const WEEKDAY_DATE_FORMAT = 'dddd, MM/DD/YYYY';

// Date & time constants
export const CALENDAR_HEADER_DATE_FORMAT = 'ddd, DD MMM';
export const CALENDAR_HOURS_FORMAT = 'hh:00a';
export const DATE_PICKER_DEFAULT_PLACEHOLDER = 'Date - MM/DD/YYYY';
export const DAY = 1;
export const DAY_HOURS = 24;
export const HOUR_MINUTES = 60;
export const HOUR_STEP = 1;
export const IDLE_TIMEOUT_MINUTES = 15;
export const MINUTE_STEP = 15;
export const TOKEN_EXPIRED_CHECKING_SECONDS = 30;
export const WEEK = 7;

// Colors
export const PROGRESS_COLOR = '#a519a0';
export const QUESTIONNAIRE_TABLE_PROGRESS_COLOR = '#c85fc4';

export const COUNTRIES = { USA: { id: 1, name: 'USA' } };

// Apps
export const ADMIN = 'admin';
export const CONTROL = 'control';
export const DASHBOARD = 'dashboard';
export const QUESTIONNAIRE = 'questionnaire';
export const FHQ = 'fhq';

// RAQ modes
export const KIOSK = 'kiosk';
export const LAUNCH = 'launch';
export const REMOTE = 'remote';

// List Multiple select
export const MULTIPLE_SELECT_MAX_CHECKED_ITEMS = 5;

// Notifications List
export const NOTIFICATIONS_LIST_MAX_LENGTH = 20;

// RAQ Names
const CANCER_RISK_ASSESSMENT = 'Cancer Risk Assessment';

export const kioskLinkMapper: Record<string, (id: number) => string> = {
  [CANCER_RISK_ASSESSMENT]: (
    (id: number): string => `${BASE_APP_URL}/${QUESTIONNAIRE}/auth/${KIOSK}/confirm-data?siteId=${id}`),
};
